<template>
    <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20"><path d="M0,0H20V20H0Z" fill="none"/><path d="M9.222,18h1.556a.913.913,0,0,0,.778-1,.913.913,0,0,0-.778-1H9.222a.913.913,0,0,0-.778,1A.913.913,0,0,0,9.222,18ZM3,7a.913.913,0,0,0,.778,1H16.222A.913.913,0,0,0,17,7a.913.913,0,0,0-.778-1H3.778A.913.913,0,0,0,3,7Zm3.111,6h7.778a.913.913,0,0,0,.778-1,.913.913,0,0,0-.778-1H6.111a.913.913,0,0,0-.778,1A.913.913,0,0,0,6.111,13Z" transform="translate(0 -2)" fill="currentColor"/></svg>
</template>

<script>
export default {
    name: "FilterIcon"
}
</script>
